import { clearAllData } from "../../configs/utils";
import { ROUTE } from "../../routes";
export const yesAction = async (action, _datastore, { navigateToBase, goBack }) => {
    clearAllData().then(() => {
        navigateToBase(ROUTE.PHONE_NUMBER);
    });
};
export const noAction = async (action, _datastore, { goBack }) => {
    await goBack();
};
